import React, { CSSProperties } from 'react';
import CloseIcon from '@/assets/icons/close.svg?react';
import { ArrowUp } from 'lucide-react';
import mixpanel from 'mixpanel-browser';

interface SupplierSelectionBarProps {
  selectedCount: number;
  onSendInquiry: () => void;
  onClose: () => void;
  disabled?: boolean;
  className?: string;
  slot?: React.ReactNode;
}

/**
 * 供应商选择栏组件
 * 设计思路：完全受控组件，显示选中的供应商数量，提供发送询盘和关闭功能
 * @param props 组件属性
 * @returns React 组件
 */
export const SupplierSelectionBar: React.FC<SupplierSelectionBarProps> = ({
  selectedCount,
  onSendInquiry,
  onClose,
  disabled = false,
  className = '',
  slot,
}) => {
  return (
    <div className={` text-white h-full  inline-flex items-center justify-between px-6 py-3 gap-3 ${className}`}>
      {/* 选择的数量展示区域 */}
      <div className="flex items-center">
        <span className="text-sm font-medium  w-max">
          Selected <span className="text-[#60A5FA]">{selectedCount}</span> suppliers
        </span>
      </div>
      {/* 分割线 */}
      <div className="h-6 w-px bg-[#525252]"></div>

      {/* send inquiry */}
      <button
        id="inquiry_start_click"
        onClick={() => {
          mixpanel.track('inquiry_start_click');
          onSendInquiry();
        }}
        className={`w-max flex items-center gap-2 text-sm font-medium  text-white hover:text-gray-200 cursor-pointer`}
      >
        <span>Send Inquiry</span>
        {slot}
        <div className=" size-[30px] rounded-full border  border-[#FFF] flex items-center justify-center">
          <ArrowUp color="#fff" size={14} className=" rotate-90" />
        </div>
      </button>

      {/* 分割线 */}
      <div className="h-6 w-px bg-[#525252]"></div>

      {/* 关闭 */}
      <button
        onClick={() => {
          mixpanel.track('inquiry_bar_close_click');
          onClose();
        }}
        disabled={disabled}
        style={
          {
            '--color': '#fff',
          } as CSSProperties
        }
        className={`p-1 ${disabled ? 'cursor-not-allowed' : 'hover:bg-gray-800 rounded-full cursor-pointer'}`}
      >
        <CloseIcon stroke="white" width={20} height={20} />
      </button>
    </div>
  );
};
